// Package imports:
import React from 'react';
// Component imports:
import Table from 'react-bootstrap/Table';
// Service imports:
import { isParameterBoolean, isParameterString } from '../../services/alertUtils';
import { formatDate } from '../../services/utils';
// Type imports:
import { IAlertConfig, IAlertConfigParameterHistoryEntry } from '../../types/api/AlertTypes';

type ExpandedHistoryEntry = IAlertConfigParameterHistoryEntry & {
    description: string
}

interface IOwnProps {
    alertConfiguration: IAlertConfig
}
type Props = IOwnProps;

const addSpacesToUsername = (username: string) => {
    return username.replace('@', '@\u200A').replaceAll('.', '.\u200A');
}

const ConfigurationModalHistoryTable: React.FC<Props> = ({
    alertConfiguration
}) => {
    const { alertConfigParameters } = alertConfiguration;
    const alertConfigParameterHistory: ExpandedHistoryEntry[] = [];
    for (let alertConfigParam of alertConfigParameters) {
        const parameterHistoryWithDescriptions: ExpandedHistoryEntry[] = alertConfigParam.alertConfigParameterHistory.map(historyEntry => ({
            ...historyEntry,
            description: alertConfigParam.description
        }));
        alertConfigParameterHistory.push(...parameterHistoryWithDescriptions);
    }

    // Sort by timestamp reverse.
    alertConfigParameterHistory.sort((historyEntry1, historyEntry2) => {
        if (new Date(historyEntry1.created_timestamp) < new Date(historyEntry2.created_timestamp)) return 1;
        if (new Date(historyEntry1.created_timestamp) > new Date(historyEntry2.created_timestamp)) return -1;
        return 0;
    });

    return (
        <Table className='CompressedTable'>
            <thead>
                <tr>
                    <th className='text-left'>Parameter</th>
                    <th className='text-center'>New Value</th>
                    <th>User</th>
                    <th>Change time</th>
                </tr>
            </thead>
            <tbody>
            {
                alertConfigParameterHistory.map((historyEntry) => (
                    <tr key={historyEntry.config_id}>
                        <td className='text-left'>{historyEntry.description}</td>
                        <td className='text-center'>
                            {
                                (isParameterBoolean(historyEntry.param_id)) // if
                                ? (
                                    <input
                                        type='checkbox'
                                        disabled
                                        className='checkbox-height-20'
                                        checked={(historyEntry.value === 1)}
                                    />
                                ) : (isParameterString(historyEntry.param_id)) // else if
                                ? historyEntry.value_text
                                : historyEntry.value
                            }
                        </td>
                        <td>{addSpacesToUsername(historyEntry.username)}</td>
                        <td>{formatDate(historyEntry.created_timestamp)}</td>
                    </tr>
                ))
            }
            </tbody>
        </Table>
    );
}

export default ConfigurationModalHistoryTable;